export default "__VITE_ASSET__z04EsPqV__"